import React, { Component } from 'react';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/MarketPlace/FilterRequests.css';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import unchecked from '../../../Assets/TruckVisits/Assets/unchecked-box.svg';
import checked from '../../../Assets/NominateRequest/selectedCheckBox.svg';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { COUNTRY_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
let locationData = [];
class FilterRequests extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            Location: '',
            searchLocationLength: 0,
            locationData1: [],
            locationDropdown: false,
            CancellationPolicyData: [],
            SelectedCancellationPolicy: [],
            PaymentMethodData: [
                { Method: "Via App" }, { Method: "Outside App" }],
            SelectedPaymentMethod: [],
            TruckTypeRequirementsdata: [
                { Type: "Tautliner" }, { Type: "Flatbed" }, { Type: "Refrigerated" }, { Type: "Lowbed" },
                { Type: "Bottom Dumper" }, { Type: "Walking Floor" }, { Type: "Side Tipper" }, { Type: "Pantech" },
                { Type: "Rigid Body" }, { Type: "Dropside" }, { Type: "Skeletal" }, { Type: "Flatbed Container" },
                { Type: "Volumax" }, { Type: "imer Trailer" }, { Type: "Dry Bulk Cement Tanker" }, { Type: "Tanker" },
                { Type: "Back End Tipper" }],
            SelectedTruckType: [],
            RadioFlag: false,
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    getCancellationPolicyData = () => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({
                        CancellationPolicyData: apiData
                    });
                    console.log('checkCP', apiData, this.state.CancellationPolicyData);
                }
            }
        });
    }
    getCountryCode = () => {
        ApiCall(
            'GET',
            utilityBaseURL + COUNTRY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    console.log("countrylocation", apiData);
                    locationData = apiData;
                }
            }
            else {
                console.log(`Some error occured - ${apiData.errorMessage}`);
            }
        });
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        this.getCountryCode();
        this.getCancellationPolicyData();
        if (!this.state.RadioFlag) {
            let a = this.state.SelectedCancellationPolicy;
            a[0] = true;
            this.setState({ SelectedCancellationPolicy: a, RadioFlag: true })
        }
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ locationDropdown: false });
        }
    };
    toggleCancellationRefundpolicyChek = () => {
        this.setState({ AcceptCancellationRefundpolicy: !this.state.AcceptCancellationRefundpolicy })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleApply = () => {
        if (this.handleValidation()) {
            let cancellationPolicy = "", paymentMethod = [], truckType = [];
            this.state.SelectedCancellationPolicy.map((selected, index) => {
                if (selected === true) {
                    cancellationPolicy = this.state.CancellationPolicyData[index].basePenalty.penaltyName;
                }
            });
            this.state.SelectedPaymentMethod.map((selected, index) => {
                if (selected === true) {
                    paymentMethod.push(this.state.PaymentMethodData[index].Method);
                }
            });
            this.state.SelectedTruckType.map((selected, index) => {
                if (selected === true) {
                    truckType.push(this.state.TruckTypeRequirementsdata[index].Type);
                }
            });
            this.props.history.push({
                pathname: `/ServiceRequest`,
                state: {
                    locationFilter: this.state.Location,
                    cancellationPolicyFilter: cancellationPolicy,
                    paymentMethodFilter: paymentMethod,
                    truckTypeRequirementsFilter: truckType,
                    filterRequestFlag: true
                }
            })
        }
    }
    handleChangeLocation = (e) => {
        if (e.target.value.length == 0) {
            this.setState({
                locationDropdown: false
            });
        }
        this.setState({ Location: e.target.value, searchLocationLength: e.target.value.length });
    }
    changeLocation = (event) => {
        const found = this.state.locationData1.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ Location: found.name });
        this.setState({ locationDropdown: !this.state.locationDropdown });
    }
    toggleSearchLocationDrop = (e) => {
        this.setState({ locationDropdown: true });
    };
    render() {
        if (this.state.searchLocationLength > 0) {
            this.state.locationData1 = locationData.filter(i => (i.name.toLowerCase()).startsWith(this.state.Location.toLowerCase()))
        } else {
            this.state.locationData1 = [];
        }
        return (
            <div class="FilterRequestsOutercolor">
                <MetaDecorator title={TitleDescription.FilterRequestTitle} description={TitleDescription.FilterRequestDescription} />
                <Header tilesFetched={() => { }} />
                <div class="FilterRequestsOuterDivcss">
                    <div id="FilterRequestsBoxDiv">
                        <nav class="FilterRequestsNavbar">
                            <div className="FilterRequestsNavbarName">
                                <small id="FilterRequestsNavbarText">Filter Requests</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="FilterRequestsMidPartition">
                            <div class="FilterRequestsHeadingText">Location</div>
                            <div class="FilterRequestLocationCardSearch">
                                <div className="pass-wrapper" id="locationInputDiv" >
                                    <Input
                                        name="SealNo1"
                                        class="input" placeholder="Enter Location"
                                        type="text" id="locationInputId" value={this.state.Location}
                                        onChange={this.handleChangeLocation}
                                        onKeyPress={this.toggleSearchLocationDrop}
                                    />
                                </div>
                                {this.state.locationDropdown && (
                                    <div class="locationInputDropdown" >
                                        <div class="dropdownContainer" ref={this.container} >
                                            {(this.state.locationData1.map((name, index) => {
                                                return (
                                                    <DropDownTable onClick={(index1) => this.changeLocation(index1)}>
                                                        <small class="" id="dropdownValue" >{name.name} </small>
                                                    </DropDownTable>
                                                );
                                            }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div class="FilterRequestsHeadingText">Cancellation Policy</div>
                            <div class="FilterRequestLocationCardTS">
                                <div class="FilterRequestsCancellationTSDiv">
                                    {(this.state.CancellationPolicyData.map((val, index) => {
                                        return (
                                            <div class="FilterRequestsCPolicyTSDiv" id={(index + 1) % 3 === 0}>
                                                <img
                                                    src={this.state.SelectedCancellationPolicy[index] ?
                                                        selectedRadioButton :
                                                        defautRadioButton
                                                    }
                                                    width="22"
                                                    height="22"
                                                    id="FilterRequestsSelect_img"
                                                    onClick={() => {
                                                        let a = this.state.SelectedCancellationPolicy;
                                                        a = a.map(x => false);
                                                        a[index] = !this.state.SelectedCancellationPolicy[index];
                                                        this.setState({ SelectedCancellationPolicy: a });
                                                    }}
                                                />
                                                <div class="FilterRequestsRadioTextDiv">{val?.basePenalty?.penaltyName}</div>
                                            </div>);
                                    }))}
                                </div>
                            </div>
                            <div class="FilterRequestsHeadingText">Payment Method</div>
                            <div class="FilterRequestLocationCardTS">
                                <div class="FilterRequestsCancellationTSDiv">
                                    {(this.state.PaymentMethodData.map((val, index) => {
                                        return (
                                            <div class="FilterRequestsCPolicyTSDiv" >
                                                <img
                                                    src={this.state.SelectedPaymentMethod[index] ?
                                                        checked :
                                                        unchecked
                                                    }
                                                    width="22"
                                                    height="22"
                                                    id="FilterRequestsSelect_img"
                                                    onClick={() => {
                                                        let a = this.state.SelectedPaymentMethod;
                                                        a[index] = !this.state.SelectedPaymentMethod[index];
                                                        this.setState({ SelectedPaymentMethod: a });
                                                    }}
                                                />
                                                <div class="FilterRequestsRadioTextDiv">{val.Method}</div>
                                            </div>);
                                    }))}
                                </div>
                            </div>
                            <div class="FilterRequestsHeadingText">Truck Type Requirements</div>
                            <div class="FilterRequestTTRequirmentCard">
                                <div class="FilterRequestsTTRequirmentDiv">
                                    {(this.state.TruckTypeRequirementsdata.map((val, index) => {
                                        return (
                                            <div class={(index + 1) % 4 === 0 ? "FilterRequestsTTReqForthDiv" : "FilterRequestsTTReqDiv"}>
                                                <img
                                                    src={this.state.SelectedTruckType[index] ?
                                                        checked :
                                                        unchecked
                                                    }
                                                    width="22"
                                                    height="22"
                                                    id="FilterRequestsSelect_img"
                                                    onClick={() => {
                                                        let a = this.state.SelectedTruckType;
                                                        a[index] = !this.state.SelectedTruckType[index];
                                                        this.setState({ SelectedTruckType: a });
                                                    }}
                                                />
                                                <div class="FilterRequestsRadioTextDiv">{val.Type}</div>
                                            </div>);
                                    }))}
                                </div>
                            </div>
                            <div id='FilterRequestsonBtnDiv' class="FilterRequestsBtnDiv">
                                <Button class="FilterRequestsBtnCss" onClick={this.handleApply}>
                                    <small class="FilterRequestsBtntext">Apply</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="FilterRequestsFooterUnfixed">
                    <Footer />
                </div>
                <div class="FilterRequestsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default FilterRequests;